import React from 'react'
import {ActionsPopovers, ActionsTooltip, BrigadeInfo, DiagnoseInfo, HospitalInfo, PatientInfo} from "../components";
import {InfoTooltipTrigger, PanelFooter} from "../../../shared";
import { Button } from '../../../ui-components';
import {changeCustomerErCallStatus} from "../../requests/er-thunk";
import {useAppDispatch, useAppSelector} from "../../../core/hooks";
import CustomerDpInfo from "../../sentry/CustomerDpInfo";
import DpEmergencyPatientInfo from "../DpEmergencyComponents/DpEmergencyPatientInfo"
import PayInfoDp from "../../sentry/DpComponents/PayInfoDp";
const StationingRequest = () => {
  const dispatch = useAppDispatch()
  const {request, pool, er_call} = useAppSelector(state => state.requests)

  return (
    <div id='stationing-request' className='request-info-container pb-80'>
      <PayInfoDp/>
      <HospitalInfo/>
      <DiagnoseInfo/>
      <BrigadeInfo/>
      {/*<PatientInfo/>*/}
      {request && request.type ===3 && <CustomerDpInfo/>}
      <DpEmergencyPatientInfo br={request}/>
      <PanelFooter>
        <Button fullWidth type='contained' onClick={() => dispatch(changeCustomerErCallStatus(12))}>Завершить</Button>
        <InfoTooltipTrigger dataFor={'actions-menu'} className='ml-15'/>
        <ActionsTooltip id='actions-menu' offsetLeft={150} offsetTop={-20}/>
      </PanelFooter>
      <ActionsPopovers/>
    </div>
  )
}

export default StationingRequest
